import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import AuthLayout from "../components/AuthLayout";
import { sendresetpasswordlink } from "../components/DbServices";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Basic Validation
    if (!email) {
      setError("Email address is required");
      return;
    }
    if (!validateEmail(email)) {
      setError("Please enter a valid email address");
      return;
    }

    try {
      setIsSubmitting(true);
      
      // Using your slice logic and common utility for form data
      const res =await sendresetpasswordlink(email);
      debugger

      if (res.status === 200) {
        await Swal.fire({
          icon: "success",
          title: "Email Sent",
          text: "Reset Password link has been sent to your inbox!",
          confirmButtonColor: "#6D28D9",
        });
        navigate("/"); 
      } else {
        Swal.fire("Error", res.message || "Email not registered", "error");
      }
    } catch (err) {
      console.error("Reset link failed:", err);
      Swal.fire(
        "Error",
        err?.data?.message || "Connection failed. Please try again.",
        "error"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthLayout
      title="Forgot Password?"
      subtitle="Enter your email to receive recovery instructions"
    >
      <form onSubmit={handleSubmit}>
        {/* EMAIL FIELD */}
        <div className="mb-4">
          <label className="form-label small fw-black text-muted mb-2 tracking-wider">
            EMAIL ADDRESS
          </label>
          <div className="input-group">
            <span className="input-group-text bg-light border-light-subtle rounded-start-3 px-3">
              <i className={`fas fa-envelope ${error ? 'text-danger' : 'text-muted'} small`}></i>
            </span>
            <input
              type="email"
              className={`form-control bg-light border-light-subtle py-3 rounded-end-3 shadow-none ${
                error ? "is-invalid" : ""
              }`}
              placeholder="e.g. alex@company.com"
              style={{ fontSize: "14px" }}
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if(error) setError(""); // Clear error when typing
              }}
            />
          </div>
          {error && (
            <div className="text-danger small fw-bold mt-2 ps-1">
              <i className="fas fa-exclamation-circle me-1"></i> {error}
            </div>
          )}
        </div>

        {/* SUBMIT BUTTON */}
        <button
          className="btn w-100 py-3 rounded-pill fw-black text-white shadow-lg border-0 transition-all hover-lift"
          style={{
            background: "linear-gradient(135deg, #6D28D9 0%, #06B6D4 100%)",
            letterSpacing: "1px",
          }}
          disabled={isSubmitting}
          type="submit"
        >
          {isSubmitting ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status"></span>
              SENDING...
            </>
          ) : (
            <>
              SEND RESET LINK <i className="fas fa-paper-plane ms-2"></i>
            </>
          )}
        </button>
      </form>

      {/* FOOTER NAV */}
      <div className="text-center mt-5">
        <p className="mb-2">
           <Link to="/" className="text-decoration-none small fw-bold text-primary hover-opacity">
            <i className="fas fa-arrow-left me-2"></i> Back to Login
          </Link>
        </p>
        <p className="text-muted small fw-medium">
          Don't have an account?{" "}
          <Link to="/register" className="text-primary fw-black text-decoration-none">
            Sign Up
          </Link>
        </p>
      </div>

      <style>{`
        .hover-lift:hover { transform: translateY(-2px); filter: brightness(1.1); transition: all 0.2s; }
        .fw-black { font-weight: 900 !important; }
        .tracking-wider { letter-spacing: 0.05rem; }
        .hover-opacity:hover { opacity: 0.8; }
      `}</style>
    </AuthLayout>
  );
};

export default ForgotPassword;